import React from "react";
import { Link } from "react-router-dom";
import {
  FaUsers,
  FaAtom,
  FaHandshake,
  FaChevronRight,
  FaLinkedin,
} from "react-icons/fa";
import "./Team.css";
import teamMembers from "./teamMembers";

// Images
import presidentImg from "../../assets/images/president.png";
import vicePresidentImg from "../../assets/images/nduma.png";
import johnImg from "../../assets/images/john.png";
import georgeImg from "../../assets/images/george.png";
import treasurerImg from "../../assets/images/treasurer.png";
import kerenImg from "../../assets/images/keren.jpg";
import peterImg from "../../assets/images/peter.png";
import recruitmentCommunicationImg from "../../assets/images/ruth.png";
import advocacyStakeholderImg from "../../assets/images/allan.png";
import collinsImg from "../../assets/images/collins.png";
import ruthImg from "../../assets/images/ruth.png";
import daisyImg from "../../assets/images/daisy.png";
import davidWImg from "../../assets/images/david.png";


// Executive Committee
const executiveCommittee = [
  {
    name: "Dr David Otwoma",
    role: "Founding President",
    image: presidentImg,
    slug: null,
  },
  {
    name: "Eng. Ndumah Ruwah",
    role: "President",
    image: vicePresidentImg,
    slug: "eng-ndumah-ruwah",
  },
  {
    name: "George Maweu",
    role: "Vice President",
    image: georgeImg,
    slug: "george-maweu",
  },
  {
    name: "Joe Mwangi",
    role: "Treasurer",
    image: treasurerImg,
    slug: "joe-mwangi",
  },
  {
    name: "Keren Omondi",
    role: "Secretary General",
    image: kerenImg,
    slug: "keren-omondi",
  },
  {
    name: "John Birir ",
    role: "Assistant General Secretary",
    image: johnImg,
    slug: "john-birir",
  },
  {
    name: "Peter Gichuki",
    role: "Technical Lead",
    image: peterImg,
    slug: "peter-gichuki",
  },
  {
    name: "Ruth Achieng",
    role: "Recruitment & Communication Representative",
    image: recruitmentCommunicationImg,
    slug: "ruth-achieng",
  },
  {
    name: "Daisy Gathoni Mbugua",
    role: "Constitutional Review and Legal Affairs Committee, Chair",
    image: daisyImg,
    slug: "daisy-gathoni-mbugua",
  },
  {
    name: "David Wanjeh",
    role: "Scientific Committee Chair",
    image: davidWImg,
    slug: "david-wanjeh",
  },
];

// Active Committees
const committees = [
  {
    title: "Scientific Committee",
    chair: { name: "David Wanjeh", image: davidWImg, slug: "david-wanjeh" },
    members: [
      { name: "Kenneth Anakoli" },
      { name: "George Maweu", image: georgeImg, slug: "george-maweu" },
      { name: "Hilda Mpakany" },
      { name: "Joe Mwangi", image: treasurerImg, slug: "joe-mwangi" },
      { name: "Dennis Kanji" },
      { name: "Caleb Odhiambo" },
    ],
  },
  {
    title: "Constitutional Review and Legal Affairs Committee",
    chair: { name: "Daisy Gathoni Mbugua", image: daisyImg, slug: "daisy-gathoni-mbugua" },
    members: [
      { name: "June Dezinavell" },
      { name: "Dennis Kiogora" },
      { name: "Mwania Muteti" },
    ],
  },
  {
    title: "Recruitment and Mentorship Committee",
    chair: null,
    members: [
      { name: "Bryan Mwaura" },
      { name: "Ruth Achieng", image: ruthImg, slug: "ruth-achieng" },
      { name: "Kelley Kimani" },
    ],
  },
  {
    title: "Education and Scholarship Committee",
    chair: null,
    members: [
      { name: "David Otwoma", image: presidentImg },
      { name: "Veronica Kihagi" },
      { name: "Ondieki Boniface Momanyi" },
      { name: "Moustapha Kassim" },
    ],
  },
  {
    title: "Advocacy and Stakeholder Engagement Committee",
    chair: null,
    members: [
      { name: "Allan Ong'onge", image: advocacyStakeholderImg, slug: "allan-ong'onge" },
      { name: "Geofry Wadegu" },
      { name: "Paulo Lopuyo Lokwawi" },
    ],
  },
  {
    title: "Resource Mobilization Committee",
    chair: null,
    members: [
      { name: "Collins Omondi", image: collinsImg },
    ],
  },
];

function getProfile(slug) {
  if (!slug) return null;
  return teamMembers.find((m) => m.slug === slug) || null;
}

function getInitials(name) {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

function CommitteeMemberLink({ member }) {
  const avatar = member.image ? (
    <img
      src={member.image}
      alt={member.name}
      className="committee-member__image"
    />
  ) : (
    <div className="committee-member__image committee-member__image--fallback">
      {getInitials(member.name)}
    </div>
  );

  const content = (
    <>
      {avatar}
      <p className="committee-member__name">{member.name}</p>
    </>
  );

  if (member.slug) {
    return (
      <Link to={`/team/${member.slug}`} className="committee-member">
        {content}
      </Link>
    );
  }

  return (
    <div className="committee-member committee-member--static">
      {content}
    </div>
  );
}

function Team() {
  return (
    <main className="team">
      {/* Hero */}
      <section className="team__hero">
        <div className="container">
          <span className="team__badge">
            Our Leadership & Committees
          </span>

          <h1>Meet the People Behind the Nuclear Society of Kenya</h1>

          <p>
            The Nuclear Society of Kenya is driven by dedicated
            professionals, researchers, engineers, educators and
            volunteers working together to advance the peaceful use of
            nuclear science and technology.
          </p>
        </div>
      </section>

      {/* Executive Committee */}
      <section className="team__section">
        <div className="container">
          <div className="team__heading">
            <FaUsers />

            <div>
              <h2>Executive Committee</h2>

              <p>
                The elected leadership responsible for the governance,
                strategy and overall direction of the Society.
              </p>
            </div>
          </div>

          <div className="team__grid">
            {executiveCommittee.map((member) => {
              const profile = getProfile(member.slug);
              const bioPreview = profile?.bio?.[0];

              return (
                <article className="member-card" key={member.name}>
                  <div className="member-card__inner">
                    <div className="member-card__face member-card__face--front">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="member-card__image"
                      />
                      <h3>{member.name}</h3>
                      <span className="member-card__role">
                        {member.role}
                      </span>
                    </div>

                    <div className="member-card__face member-card__face--back">
                      <h3>{member.name}</h3>
                      {bioPreview ? (
                        <p className="member-card__bio">{bioPreview}</p>
                      ) : (
                        <p className="member-card__bio member-card__bio--placeholder">
                          Full bio coming soon.
                        </p>
                      )}
                      <div className="member-card__back-actions">
                        {profile?.linkedin && (
                          <a
                            href={profile.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="member-card__linkedin"
                            aria-label={`${member.name} on LinkedIn`}
                          >
                            <FaLinkedin size={22} />
                          </a>
                        )}
                        {profile && (
                          <Link
                            to={`/team/${profile.slug}`}
                            className="member-card__view-more"
                          >
                            Full profile →
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* Active Committees */}
      <section className="team__section team__section--light">
        <div className="container">
          <div className="team__heading">
            <FaAtom />

            <div>
              <h2>Active Committees</h2>

              <p>
                NSK committees support education, advocacy, recruitment,
                constitutional review, stakeholder engagement, and resource
                mobilization across the Society.
              </p>
            </div>
          </div>

          <div className="committee-grid">
            {committees.map((committee) => (
              <div className="committee-card" key={committee.title}>
                <FaAtom className="committee-card__icon" />

                <h3>{committee.title}</h3>

                {committee.chair && (
                  <div className="committee-chair">
                    <span className="committee-chair__badge">Chair</span>
                    <CommitteeMemberLink member={committee.chair} />
                  </div>
                )}

                <div className="committee-members">
                  {committee.members.map((member) => (
                    <CommitteeMemberLink
                      key={member.slug || member.name}
                      member={member}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="team__cta">
        <div className="container">
          <FaHandshake className="team__cta-icon" />

          <h2>Want to Serve on a Committee?</h2>

          <p>
            NSK welcomes professionals, researchers and students who
            wish to contribute their expertise and help strengthen
            Kenya's nuclear science community.
          </p>

          <Link to="/join" className="btn btn--primary">
            Join NSK
            <FaChevronRight style={{ marginLeft: "8px" }} />
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Team;